export const bookList = {
	"10118": {
		"status": true,
		"code": "200",
		"msg": "success",
		"errorMsg": "",
		"data": {
			"total": 0,
			"size": 8,
			"pages": 0,
			"current": 1,
			"records": []
		}
	},
	"10128": {
		"status": true,
		"code": "200",
		"msg": "success",
		"errorMsg": "",
		"data": {
			"total": 0,
			"size": 8,
			"pages": 0,
			"current": 1,
			"records": [{
				"goodsId": 4910106,
				"gid": 4910106,
				"goodsType": 1,
				"price": 98.0000,
				"discount": 1,
				"discountPrice": 98.0000,
				"currency": 1,
				"createTime": "2026-02-27 14:58:40",
				"cnIbraryType": "K203-53",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/yFjn8O5zx.jpg",
				"topic": "中国艺术研究院学术文库——遮蔽的文明",
				"title": "中国艺术研究院学术文库——遮蔽的文明",
				"author": "陈绶祥著",
				"isbn": "9787569952186",
				"publisher": "北京时代华文书局",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4910110,
				"gid": 4910110,
				"goodsType": 1,
				"price": 95.0000,
				"discount": 1,
				"discountPrice": 95.0000,
				"currency": 1,
				"createTime": "2026-02-27 14:58:40",
				"cnIbraryType": "K203-53",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/msarA3yKf.jpg",
				"topic": "中国艺术研究院学术文库——我的反省与思考",
				"title": "中国艺术研究院学术文库——我的反省与思考",
				"author": "田青著",
				"isbn": "9787569952063",
				"publisher": "北京时代华文书局",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4769448,
				"gid": 4769448,
				"goodsType": 1,
				"price": 198.0000,
				"discount": 1,
				"discountPrice": 198.0000,
				"currency": 1,
				"createTime": "2026-02-27 14:58:41",
				"cnIbraryType": "K103",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/KwFg7g8Y7.jpg",
				"topic": "人类文明史：中国人的文明观(全2册)",
				"title": "人类文明史：中国人的文明观(全2册)",
				"author": "强光中著",
				"isbn": "9787516926307",
				"publisher": "华龄出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 5007205,
				"gid": 5007205,
				"goodsType": 1,
				"price": 98.0000,
				"discount": 1,
				"discountPrice": 98.0000,
				"currency": 1,
				"createTime": "2026-02-27 14:58:41",
				"cnIbraryType": "K203-53",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/tSr3rZG53.jpg",
				"topic": "中国艺术研究院学术文库——“文化自觉”视野中的“非遗”保护",
				"title": "中国艺术研究院学术文库——“文化自觉”视野中的“非遗”保护",
				"author": "方李莉著",
				"isbn": "9787569951745",
				"publisher": "北京时代华文书局",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 5007172,
				"gid": 5007172,
				"goodsType": 1,
				"price": 98.0000,
				"discount": 1,
				"discountPrice": 98.0000,
				"currency": 1,
				"createTime": "2026-02-27 14:58:41",
				"cnIbraryType": "K203-53",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/1LP3tP8Ew.jpg",
				"topic": "中国艺术研究院学术文库——民俗学与遗产学视域下的乡土中国",
				"title": "中国艺术研究院学术文库——民俗学与遗产学视域下的乡土中国",
				"author": "苑利著",
				"isbn": "9787569952445",
				"publisher": "北京时代华文书局",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4873417,
				"gid": 4873417,
				"goodsType": 1,
				"price": 48.0000,
				"discount": 1,
				"discountPrice": 48.0000,
				"currency": 1,
				"createTime": "2026-02-27 16:01:01",
				"cnIbraryType": "K109",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/axGYdxjtb.jpg",
				"topic": "怪诞历史",
				"title": "怪诞历史",
				"author": "朱广思",
				"isbn": "9787547751497",
				"publisher": "北京日报出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4908619,
				"gid": 4908619,
				"goodsType": 1,
				"price": 98.0000,
				"discount": 1,
				"discountPrice": 98.0000,
				"currency": 1,
				"createTime": "2026-02-28 08:33:15",
				"cnIbraryType": "K244.09",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/XVmbONYMk.jpg",
				"topic": "两宋风云：从盛世繁华到风雨飘摇",
				"title": "两宋风云：从盛世繁华到风雨飘摇",
				"author": "丁守卫 著",
				"isbn": "9787113324674",
				"publisher": "中国铁道出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4762846,
				"gid": 4762846,
				"goodsType": 1,
				"price": 99.0000,
				"discount": 1,
				"discountPrice": 99.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:57:00",
				"cnIbraryType": "K203",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/ktDWQELZ8.jpg",
				"topic": "寻古中国",
				"title": "寻古中国",
				"author": "《寻古中国》节目组 编著",
				"isbn": "9787108079299",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}]
		}
	},
	"10129": {
		"status": true,
		"code": "200",
		"msg": "success",
		"errorMsg": "",
		"data": {
			"total": 0,
			"size": 8,
			"pages": 0,
			"current": 1,
			"records": [{
				"goodsId": 4994149,
				"gid": 4994149,
				"goodsType": 1,
				"price": 52.0000,
				"discount": 1,
				"discountPrice": 52.0000,
				"currency": 1,
				"createTime": "2026-02-27 16:01:01",
				"cnIbraryType": "B848.4",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/149YkUwP8.jpg",
				"topic": "起势",
				"title": "起势",
				"author": "洛水",
				"isbn": "9787547753118",
				"publisher": "北京日报出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4825724,
				"gid": 4825724,
				"goodsType": 1,
				"price": 49.9000,
				"discount": 1,
				"discountPrice": 49.9000,
				"currency": 1,
				"createTime": "2026-02-27 17:51:54",
				"cnIbraryType": "B84-49",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/B8ECoyJid.jpg",
				"topic": "孩子要知道的生存法则 给孩子看的漫画乌合之众",
				"title": "孩子要知道的生存法则 给孩子看的漫画乌合之众",
				"author": "布克熊",
				"isbn": "9787519483838",
				"publisher": "光明日报出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4875692,
				"gid": 4875692,
				"goodsType": 1,
				"price": 58.0000,
				"discount": 1,
				"discountPrice": 58.0000,
				"currency": 1,
				"createTime": "2026-02-27 17:51:54",
				"cnIbraryType": "B848.4-49",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/aVvJwhNRd.jpg",
				"topic": "孩子要知道的生存法则  给孩子看的漫画认知觉醒",
				"title": "孩子要知道的生存法则  给孩子看的漫画认知觉醒",
				"author": "布克熊",
				"isbn": "9787519487904",
				"publisher": "光明日报出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 5008709,
				"gid": 5008709,
				"goodsType": 1,
				"price": 58.0000,
				"discount": 1,
				"discountPrice": 58.0000,
				"currency": 1,
				"createTime": "2026-02-27 17:51:54",
				"cnIbraryType": "B848.4-49",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/Yv9Ysykj7.jpg",
				"topic": "世间大雨滂沱，你要藏好软弱",
				"title": "世间大雨滂沱，你要藏好软弱",
				"author": "林子树",
				"isbn": "9787514248333",
				"publisher": "文化发展出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4995631,
				"gid": 4995631,
				"goodsType": 1,
				"price": 45.0000,
				"discount": 1,
				"discountPrice": 45.0000,
				"currency": 1,
				"createTime": "2026-03-02 14:41:53",
				"cnIbraryType": "B848.4-49",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/obbqGqT4t.jpg",
				"topic": "因为抑郁，所以全力奔跑",
				"title": "因为抑郁，所以全力奔跑",
				"author": "尚喵",
				"isbn": "9787573634696",
				"publisher": "青岛出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4998082,
				"gid": 4998082,
				"goodsType": 1,
				"price": 55.0000,
				"discount": 1,
				"discountPrice": 55.0000,
				"currency": 1,
				"createTime": "2026-03-03 13:58:37",
				"cnIbraryType": "B84-49",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/sz7yz0TpI.jpg",
				"topic": "揭秘煤气灯效应--心理操控的哲学透视(密涅瓦·思辨万象)",
				"title": "揭秘煤气灯效应--心理操控的哲学透视(密涅瓦·思辨万象)",
				"author": "",
				"isbn": "9787208198616",
				"publisher": "上海人民出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 5010261,
				"gid": 5010261,
				"goodsType": 1,
				"price": 68.0000,
				"discount": 1,
				"discountPrice": 68.0000,
				"currency": 1,
				"createTime": "2026-03-03 13:58:37",
				"cnIbraryType": "B842.6-49",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/0DxjRUoDd.jpg",
				"topic": "摆脱困境",
				"title": "摆脱困境",
				"author": "",
				"isbn": "9787547622216",
				"publisher": "上海人民出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4950903,
				"gid": 4950903,
				"goodsType": 1,
				"price": 69.8000,
				"discount": 1,
				"discountPrice": 69.8000,
				"currency": 1,
				"createTime": "2026-03-03 14:29:49",
				"cnIbraryType": "B844.2",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/iuwVOvQOR.jpg",
				"topic": "如何与青少年对话才有用:帮助青少年在竞争激烈、电子产品泛滥的世界中健康成长",
				"title": "如何与青少年对话才有用:帮助青少年在竞争激烈、电子产品泛滥的世界中健康成长",
				"author": "(美)珍妮特·萨森·埃杰特著",
				"isbn": "9787520745437",
				"publisher": "东方出版社",
				"selectNum": 0,
				"allNum": 0
			}]
		}
	},
	"10130": {
		"status": true,
		"code": "200",
		"msg": "success",
		"errorMsg": "",
		"data": {
			"total": 0,
			"size": 8,
			"pages": 0,
			"current": 1,
			"records": [{
				"goodsId": 5000867,
				"gid": 5000867,
				"goodsType": 1,
				"price": 79.0000,
				"discount": 1,
				"discountPrice": 79.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:56:59",
				"cnIbraryType": "J609.1",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/FpshbMw4E.jpg",
				"topic": "走向全球音乐史：人类音乐进程中的跨文化交汇、融合与转型",
				"title": "走向全球音乐史：人类音乐进程中的跨文化交汇、融合与转型",
				"author": "[美]马克·海吉勒",
				"isbn": "9787108081391",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4985934,
				"gid": 4985934,
				"goodsType": 1,
				"price": 88.0000,
				"discount": 1,
				"discountPrice": 88.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:56:59",
				"cnIbraryType": "J212.052-53",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/J80HC5SbE.jpg",
				"topic": "上架集",
				"title": "上架集",
				"author": "怀一 画  随寓 文",
				"isbn": "9787108082367",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4851724,
				"gid": 4851724,
				"goodsType": 1,
				"price": 79.0000,
				"discount": 1,
				"discountPrice": 79.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:57:00",
				"cnIbraryType": "J222.7",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/DW9rqeB0s.jpg",
				"topic": "只有花儿不会老",
				"title": "只有花儿不会老",
				"author": "江宏伟",
				"isbn": "9787108080134",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4830160,
				"gid": 4830160,
				"goodsType": 1,
				"price": 96.0000,
				"discount": 1,
				"discountPrice": 96.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:57:00",
				"cnIbraryType": "J909.2",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/Sivjujzl8.jpg",
				"topic": "中国动画：中国美术电影发展史",
				"title": "中国动画：中国美术电影发展史",
				"author": "[日]小野耕世",
				"isbn": "9787108079947",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4843382,
				"gid": 4843382,
				"goodsType": 1,
				"price": 197.0000,
				"discount": 1,
				"discountPrice": 197.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:57:00",
				"cnIbraryType": "J239",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/yZTXXmmMt.jpg",
				"topic": "黑白",
				"title": "黑白",
				"author": "汪家明 编",
				"isbn": "9787108080547",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4851722,
				"gid": 4851722,
				"goodsType": 1,
				"price": 188.0000,
				"discount": 1,
				"discountPrice": 188.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:57:00",
				"cnIbraryType": "J228.4",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/V6K0p2FrK.jpg",
				"topic": "封神绘",
				"title": "封神绘",
				"author": "沈延 绘著",
				"isbn": "9787108080226",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4756115,
				"gid": 4756115,
				"goodsType": 1,
				"price": 98.0000,
				"discount": 1,
				"discountPrice": 98.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:57:00",
				"cnIbraryType": "J120.95",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/sx1goXTif.jpg",
				"topic": "上水船：王逊与现代中国的艺术理想",
				"title": "上水船：王逊与现代中国的艺术理想",
				"author": "王涵 口述  段牛斗 王瑀 整理",
				"isbn": "9787108078773",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4826517,
				"gid": 4826517,
				"goodsType": 1,
				"price": 338.0000,
				"discount": 1,
				"discountPrice": 338.0000,
				"currency": 1,
				"createTime": "2026-03-02 10:17:17",
				"cnIbraryType": "J222.5",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/QHASY7SfJ.jpg",
				"topic": "御窑遗韵　瓷上丹青 : 清末民国浅绛彩瓷画大师作品",
				"title": "御窑遗韵　瓷上丹青 : 清末民国浅绛彩瓷画大师作品",
				"author": "吕贤明",
				"isbn": "9787536281820",
				"publisher": "岭南美术出版社",
				"selectNum": 0,
				"allNum": 0
			}]
		}
	},
	"10131": {
		"status": true,
		"code": "200",
		"msg": "success",
		"errorMsg": "",
		"data": {
			"total": 0,
			"size": 8,
			"pages": 0,
			"current": 1,
			"records": [{
				"goodsId": 4998255,
				"gid": 4998255,
				"goodsType": 1,
				"price": 58.0000,
				"discount": 1,
				"discountPrice": 58.0000,
				"currency": 1,
				"createTime": "2026-03-02 14:41:53",
				"cnIbraryType": "TS972.161",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/pr2CwWyxv.jpg",
				"topic": "极简漫画饮食术",
				"title": "极简漫画饮食术",
				"author": "圆尾和纪",
				"isbn": "9787573636652",
				"publisher": "青岛出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4965966,
				"gid": 4965966,
				"goodsType": 1,
				"price": 88.0000,
				"discount": 1,
				"discountPrice": 88.0000,
				"currency": 1,
				"createTime": "2026-03-03 10:05:44",
				"cnIbraryType": "TS974.11",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/VCnjJqDky.jpg",
				"topic": "皮肤的救赎",
				"title": "皮肤的救赎",
				"author": "王慧 陆唯怡 季星 梅鹤祥 主编",
				"isbn": "9787547874448",
				"publisher": "上海科学技术出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4899993,
				"gid": 4899993,
				"goodsType": 1,
				"price": 45.0000,
				"discount": 1,
				"discountPrice": 45.0000,
				"currency": 1,
				"createTime": "2026-03-03 10:05:44",
				"cnIbraryType": "TS974.11",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/1YTGT53Tv.jpg",
				"topic": "油痘不再焦虑：皮肤的科学护理",
				"title": "油痘不再焦虑：皮肤的科学护理",
				"author": "鞠强 鲍晶琳 李成亮 主编",
				"isbn": "9787547873267",
				"publisher": "上海科学技术出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4953911,
				"gid": 4953911,
				"goodsType": 1,
				"price": 60.0000,
				"discount": 1,
				"discountPrice": 60.0000,
				"currency": 1,
				"createTime": "2026-03-03 10:11:25",
				"cnIbraryType": "TS971.201",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/FP2Gs6Xkd.jpg",
				"topic": "魔鬼的野餐：环球禁忌美食之旅",
				"title": "魔鬼的野餐：环球禁忌美食之旅",
				"author": "[加]高泰若 著",
				"isbn": "9787100250733",
				"publisher": "商务印书馆有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4987795,
				"gid": 4987795,
				"goodsType": 1,
				"price": 62.0000,
				"discount": 1,
				"discountPrice": 62.0000,
				"currency": 1,
				"createTime": "2026-03-03 10:11:26",
				"cnIbraryType": "TS971.22",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/39nxNnNpY.jpg",
				"topic": "啤酒史",
				"title": "啤酒史",
				"author": "刘群艺 著",
				"isbn": "9787100252492",
				"publisher": "商务印书馆有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4883215,
				"gid": 4883215,
				"goodsType": 1,
				"price": 69.0000,
				"discount": 1,
				"discountPrice": 69.0000,
				"currency": 1,
				"createTime": "2026-03-03 10:16:32",
				"cnIbraryType": "TS972.182.71",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/u3CSkarS3.jpg",
				"topic": "川菜东征记",
				"title": "川菜东征记",
				"author": "",
				"isbn": "9787807684879",
				"publisher": "生活书店出版有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 5010379,
				"gid": 5010379,
				"goodsType": 1,
				"price": 88.0000,
				"discount": 1,
				"discountPrice": 88.0000,
				"currency": 1,
				"createTime": "2026-03-03 10:16:32",
				"cnIbraryType": "TS972.182",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/XiK9VWyNr.jpg",
				"topic": "口福：传统中国菜一百品",
				"title": "口福：传统中国菜一百品",
				"author": "",
				"isbn": "9787807684602",
				"publisher": "生活书店出版有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 5000388,
				"gid": 5000388,
				"goodsType": 1,
				"price": 78.0000,
				"discount": 1,
				"discountPrice": 78.0000,
				"currency": 1,
				"createTime": "2026-03-03 13:58:37",
				"cnIbraryType": "TS971.2",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/G5s56y5nI.jpg",
				"topic": "燕窝之补:多重世界中的记忆与感知",
				"title": "燕窝之补:多重世界中的记忆与感知",
				"author": "",
				"isbn": "9787208198807",
				"publisher": "上海人民出版社",
				"selectNum": 0,
				"allNum": 0
			}]
		}
	},
	"10132": {
		"status": true,
		"code": "200",
		"msg": "success",
		"errorMsg": "",
		"data": {
			"total": 0,
			"size": 8,
			"pages": 0,
			"current": 1,
			"records": [{
				"goodsId": 4886921,
				"gid": 4886921,
				"goodsType": 1,
				"price": 46.0000,
				"discount": 1,
				"discountPrice": 46.0000,
				"currency": 1,
				"createTime": "2026-02-27 14:17:12",
				"cnIbraryType": "Q959.7-49",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/REIDr2hsq.jpg",
				"topic": "全家福",
				"title": "全家福",
				"author": "克洛伊·米勒",
				"isbn": "9787530689172",
				"publisher": "百花文艺出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4770109,
				"gid": 4770109,
				"goodsType": 1,
				"price": 35.0000,
				"discount": 1,
				"discountPrice": 35.0000,
				"currency": 1,
				"createTime": "2026-03-02 14:41:53",
				"cnIbraryType": "I247.5",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/7TQX3TqYb.jpg",
				"topic": "大运水生",
				"title": "大运水生",
				"author": "刘北",
				"isbn": "9787573627698",
				"publisher": "青岛出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4787910,
				"gid": 4787910,
				"goodsType": 1,
				"price": 38.0000,
				"discount": 1,
				"discountPrice": 38.0000,
				"currency": 1,
				"createTime": "2026-03-02 14:41:53",
				"cnIbraryType": "I287.45",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/ecAlBEZf3.jpg",
				"topic": "廖崩嗒佩合唱团",
				"title": "廖崩嗒佩合唱团",
				"author": "肖勤",
				"isbn": "9787573629289",
				"publisher": "青岛出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4882485,
				"gid": 4882485,
				"goodsType": 1,
				"price": 36.0000,
				"discount": 1,
				"discountPrice": 36.0000,
				"currency": 1,
				"createTime": "2026-03-02 14:41:53",
				"cnIbraryType": "I247.5",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/T1TfDVeko.jpg",
				"topic": "谷满家的黑球",
				"title": "谷满家的黑球",
				"author": "郝周",
				"isbn": "9787573633972",
				"publisher": "青岛出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4978096,
				"gid": 4978096,
				"goodsType": 1,
				"price": 68.0000,
				"discount": 1,
				"discountPrice": 68.0000,
				"currency": 1,
				"createTime": "2026-03-03 09:41:25",
				"cnIbraryType": "Z228.2",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/Gh2B1Ssuj.jpg",
				"topic": "藏在歌曲里的科学",
				"title": "藏在歌曲里的科学",
				"author": "徐海 甘淋玲 黄湘红 主编",
				"isbn": "9787542885722",
				"publisher": "上海科技教育出版社有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4798740,
				"gid": 4798740,
				"goodsType": 1,
				"price": 39.8000,
				"discount": 1,
				"discountPrice": 39.8000,
				"currency": 1,
				"createTime": "2026-03-03 14:29:48",
				"cnIbraryType": "A762-49",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/iIlLc0t1S.jpg",
				"topic": "少年邓小平",
				"title": "少年邓小平",
				"author": "徐鲁著",
				"isbn": "9787520741132",
				"publisher": "东方出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4955774,
				"gid": 4955774,
				"goodsType": 1,
				"price": 68.0000,
				"discount": 1,
				"discountPrice": 68.0000,
				"currency": 1,
				"createTime": "2026-03-03 17:23:48",
				"cnIbraryType": "I565.85",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/5VdEyOJyA.jpg",
				"topic": "兔子雅各的生命颂歌",
				"title": "兔子雅各的生命颂歌",
				"author": "",
				"isbn": "9787559497758",
				"publisher": "江苏凤凰文艺出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4956529,
				"gid": 4956529,
				"goodsType": 1,
				"price": 49.8000,
				"discount": 1,
				"discountPrice": 49.8000,
				"currency": 1,
				"createTime": "2026-03-03 17:33:32",
				"cnIbraryType": "I313.85",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/Gh5WZUxFU.jpg",
				"topic": "牛奶洒了没关系",
				"title": "牛奶洒了没关系",
				"author": "铃木典丈",
				"isbn": "9787550743557",
				"publisher": "深圳出版社",
				"selectNum": 0,
				"allNum": 0
			}]
		}
	},
	"10133": {
		"status": true,
		"code": "200",
		"msg": "success",
		"errorMsg": "",
		"data": {
			"total": 0,
			"size": 8,
			"pages": 0,
			"current": 1,
			"records": [{
				"goodsId": 5008890,
				"gid": 5008890,
				"goodsType": 1,
				"price": 128.0000,
				"discount": 1,
				"discountPrice": 128.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:56:59",
				"cnIbraryType": "K512.46",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/CbLjzEQBy.jpg",
				"topic": "俄国革命：彼得格勒，1917年2月",
				"title": "俄国革命：彼得格勒，1917年2月",
				"author": "[日]和田春树",
				"isbn": "9787108079428",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 5000868,
				"gid": 5000868,
				"goodsType": 1,
				"price": 86.0000,
				"discount": 1,
				"discountPrice": 86.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:56:59",
				"cnIbraryType": "I512.06",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/61MY66prD.jpg",
				"topic": "世界感：俄国文学与地缘政治",
				"title": "世界感：俄国文学与地缘政治",
				"author": "初金一",
				"isbn": "9787108082305",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 5001014,
				"gid": 5001014,
				"goodsType": 1,
				"price": 78.0000,
				"discount": 1,
				"discountPrice": 78.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:56:59",
				"cnIbraryType": "B821",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/rwLLLLdWM.jpg",
				"topic": "中西之外：华夏世界观与人类学",
				"title": "中西之外：华夏世界观与人类学",
				"author": "梁永佳",
				"isbn": "9787108081728",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4985935,
				"gid": 4985935,
				"goodsType": 1,
				"price": 82.0000,
				"discount": 1,
				"discountPrice": 82.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:56:59",
				"cnIbraryType": "K825.1",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/jXbpDWSIy.jpg",
				"topic": "一神论的影子：哲学家与人类学家的通信",
				"title": "一神论的影子：哲学家与人类学家的通信",
				"author": "赵汀阳  [法]阿兰·乐比雄",
				"isbn": "9787108081957",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4985932,
				"gid": 4985932,
				"goodsType": 1,
				"price": 88.0000,
				"discount": 1,
				"discountPrice": 88.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:56:59",
				"cnIbraryType": "B821",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/6F3ujgzDA.jpg",
				"topic": "形而上的动物：女性如何让哲学重归生活",
				"title": "形而上的动物：女性如何让哲学重归生活",
				"author": "[爱尔兰]克莱尔·麦卡尔 [英]瑞秋·威",
				"isbn": "9787108081452",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4955560,
				"gid": 4955560,
				"goodsType": 1,
				"price": 169.0000,
				"discount": 1,
				"discountPrice": 169.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:56:59",
				"cnIbraryType": "K87",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/EaleKsq6E.jpg",
				"topic": "国家记忆：故宫文物南迁史",
				"title": "国家记忆：故宫文物南迁史",
				"author": "郑欣淼",
				"isbn": "9787108081650",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4954614,
				"gid": 4954614,
				"goodsType": 1,
				"price": 148.0000,
				"discount": 1,
				"discountPrice": 148.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:56:59",
				"cnIbraryType": "I206.2-53",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/UyD6Fl2bO.jpg",
				"topic": "宇文所安教授荣休纪念论文集",
				"title": "宇文所安教授荣休纪念论文集",
				"author": "洪越 编  张淑香 杨晓山 林葆玲 等著",
				"isbn": "9787108080370",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4967610,
				"gid": 4967610,
				"goodsType": 1,
				"price": 79.9000,
				"discount": 1,
				"discountPrice": 79.9000,
				"currency": 1,
				"createTime": "2026-02-28 16:10:14",
				"cnIbraryType": "K878.8-49",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/lhUsPjCyU.jpg",
				"topic": "地下王朝：古猫讲中国墓葬",
				"title": "地下王朝：古猫讲中国墓葬",
				"author": "古猫|陪你去看博物馆",
				"isbn": "9787203141488",
				"publisher": "山西人民出版社",
				"selectNum": 0,
				"allNum": 0
			}]
		}
	},
	"10134": {
		"status": true,
		"code": "200",
		"msg": "success",
		"errorMsg": "",
		"data": {
			"total": 0,
			"size": 8,
			"pages": 0,
			"current": 1,
			"records": [{
				"goodsId": 4955059,
				"gid": 4955059,
				"goodsType": 1,
				"price": 99.0000,
				"discount": 1,
				"discountPrice": 99.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:56:59",
				"cnIbraryType": "I730.06",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/OAbFhrab9.jpg",
				"topic": "“文学爆炸”那些年",
				"title": "“文学爆炸”那些年",
				"author": "[西班牙]哈维·阿延",
				"isbn": "9787108081056",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4961226,
				"gid": 4961226,
				"goodsType": 1,
				"price": 69.0000,
				"discount": 1,
				"discountPrice": 69.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:56:59",
				"cnIbraryType": "I210",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/YjDo0ATSj.jpg",
				"topic": "鲁迅与周作人",
				"title": "鲁迅与周作人",
				"author": "孙郁",
				"isbn": "9787108081070",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4914787,
				"gid": 4914787,
				"goodsType": 1,
				"price": 69.0000,
				"discount": 1,
				"discountPrice": 69.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:56:59",
				"cnIbraryType": "I209.44",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/mZ94bU5KV.jpg",
				"topic": "悉为我有！：11世纪中国的快乐、拥有、命名",
				"title": "悉为我有！：11世纪中国的快乐、拥有、命名",
				"author": "[美]宇文所安",
				"isbn": "9787108080257",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4954612,
				"gid": 4954612,
				"goodsType": 1,
				"price": 68.0000,
				"discount": 1,
				"discountPrice": 68.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:56:59",
				"cnIbraryType": "I712.65",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/yV9TVVeOP.jpg",
				"topic": "低吟的荒野",
				"title": "低吟的荒野",
				"author": "[美]西格德·奥尔森",
				"isbn": "9787108081612",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4943253,
				"gid": 4943253,
				"goodsType": 1,
				"price": 58.0000,
				"discount": 1,
				"discountPrice": 58.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:56:59",
				"cnIbraryType": "I267.1",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/1FUFJmo1h.jpg",
				"topic": "山河万里：重走抗战时期大学内迁之路",
				"title": "山河万里：重走抗战时期大学内迁之路",
				"author": "聂作平",
				"isbn": "9787108081209",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4912947,
				"gid": 4912947,
				"goodsType": 1,
				"price": 69.0000,
				"discount": 1,
				"discountPrice": 69.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:56:59",
				"cnIbraryType": "I313.65",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/FnqUzAvuW.jpg",
				"topic": "漫游见闻录",
				"title": "漫游见闻录",
				"author": "[日]黑田清隆",
				"isbn": "9787108080943",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4908577,
				"gid": 4908577,
				"goodsType": 1,
				"price": 69.0000,
				"discount": 1,
				"discountPrice": 69.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:56:59",
				"cnIbraryType": "I267.1",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/92PqEyJ7W.jpg",
				"topic": "情绪力：从内心开发天地",
				"title": "情绪力：从内心开发天地",
				"author": "澄海",
				"isbn": "9787108081544",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4894059,
				"gid": 4894059,
				"goodsType": 1,
				"price": 79.0000,
				"discount": 1,
				"discountPrice": 79.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:56:59",
				"cnIbraryType": "I267.1",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/fKffGUBD3.jpg",
				"topic": "百年旧痕：赵珩谈北京",
				"title": "百年旧痕：赵珩谈北京",
				"author": "赵珩 口述审订  李昶伟 录音采写",
				"isbn": "9787108081049",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}]
		}
	},
	"10135": {
		"status": true,
		"code": "200",
		"msg": "success",
		"errorMsg": "",
		"data": {
			"total": 0,
			"size": 8,
			"pages": 0,
			"current": 1,
			"records": [{
				"goodsId": 4825303,
				"gid": 4825303,
				"goodsType": 1,
				"price": 60.0000,
				"discount": 1,
				"discountPrice": 60.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:57:00",
				"cnIbraryType": "D651.9",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/n7xiwpABc.jpg",
				"topic": "走出困境",
				"title": "走出困境",
				"author": "罗平汉",
				"isbn": "9787108080059",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4825311,
				"gid": 4825311,
				"goodsType": 1,
				"price": 63.0000,
				"discount": 1,
				"discountPrice": 63.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:57:00",
				"cnIbraryType": "D663.5",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/tGlOlsLaW.jpg",
				"topic": "认同与信任",
				"title": "认同与信任",
				"author": "罗平汉",
				"isbn": "9787108080189",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4825300,
				"gid": 4825300,
				"goodsType": 1,
				"price": 59.0000,
				"discount": 1,
				"discountPrice": 59.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:57:00",
				"cnIbraryType": "D651.9",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/WIHklHt4E.jpg",
				"topic": "特殊的印记",
				"title": "特殊的印记",
				"author": "罗平汉",
				"isbn": "9787108080172",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4825309,
				"gid": 4825309,
				"goodsType": 1,
				"price": 59.0000,
				"discount": 1,
				"discountPrice": 59.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:57:00",
				"cnIbraryType": "D232",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/K7mif4xDq.jpg",
				"topic": "变革与改造",
				"title": "变革与改造",
				"author": "罗平汉",
				"isbn": "9787108080158",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4953617,
				"gid": 4953617,
				"goodsType": 1,
				"price": 70.0000,
				"discount": 1,
				"discountPrice": 70.0000,
				"currency": 1,
				"createTime": "2026-03-03 10:11:25",
				"cnIbraryType": "D693.71",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/9kq1kadgR.jpg",
				"topic": "出版的力量：清末至新中国初期的知识分子与工业化出版",
				"title": "出版的力量：清末至新中国初期的知识分子与工业化出版",
				"author": "[美]高哲一 著",
				"isbn": "9787100243285",
				"publisher": "商务印书馆有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4970879,
				"gid": 4970879,
				"goodsType": 1,
				"price": 78.0000,
				"discount": 1,
				"discountPrice": 78.0000,
				"currency": 1,
				"createTime": "2026-03-03 10:11:25",
				"cnIbraryType": "D6-53",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/ty2R3GbeG.jpg",
				"topic": "大学之问：燕继荣演讲录",
				"title": "大学之问：燕继荣演讲录",
				"author": "燕继荣 著",
				"isbn": "9787100257701",
				"publisher": "商务印书馆有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4977924,
				"gid": 4977924,
				"goodsType": 1,
				"price": 62.0000,
				"discount": 1,
				"discountPrice": 62.0000,
				"currency": 1,
				"createTime": "2026-03-03 13:58:37",
				"cnIbraryType": "D262",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/JqISOMKrQ.jpg",
				"topic": "新时代加强组织制度建设研究(新时代党的组织路线研究丛书)",
				"title": "新时代加强组织制度建设研究(新时代党的组织路线研究丛书)",
				"author": "",
				"isbn": "9787208199293",
				"publisher": "上海人民出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4954312,
				"gid": 4954312,
				"goodsType": 1,
				"price": 69.0000,
				"discount": 1,
				"discountPrice": 69.0000,
				"currency": 1,
				"createTime": "2026-03-03 13:58:38",
				"cnIbraryType": "D625",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/O6FoBEDlh.jpg",
				"topic": "基层中国的运行逻辑",
				"title": "基层中国的运行逻辑",
				"author": "",
				"isbn": "9787208197473",
				"publisher": "上海人民出版社",
				"selectNum": 0,
				"allNum": 0
			}]
		}
	},
	"10145": {
		"status": true,
		"code": "200",
		"msg": "success",
		"errorMsg": "",
		"data": {
			"total": 0,
			"size": 8,
			"pages": 0,
			"current": 1,
			"records": [{
				"goodsId": 4800400,
				"gid": 4800400,
				"goodsType": 1,
				"price": 148.0000,
				"discount": 1,
				"discountPrice": 148.0000,
				"currency": 1,
				"createTime": "2026-03-03 10:05:45",
				"cnIbraryType": "F407.4",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/b5V6iDxoA.jpg",
				"topic": "智造未来：AI引领高效、灵活、低成本生产新纪元",
				"title": "智造未来：AI引领高效、灵活、低成本生产新纪元",
				"author": "[美]约翰·索尔达托斯 主编；李传江 于丽娅 译",
				"isbn": "9787547870433",
				"publisher": "上海科学技术出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4983905,
				"gid": 4983905,
				"goodsType": 1,
				"price": 68.0000,
				"discount": 1,
				"discountPrice": 68.0000,
				"currency": 1,
				"createTime": "2026-03-03 13:58:37",
				"cnIbraryType": "F840",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/pgWBIz3qn.jpg",
				"topic": "保险的金融经济学(当代经济学系列丛书·当代经济学译库)",
				"title": "保险的金融经济学(当代经济学系列丛书·当代经济学译库)",
				"author": "",
				"isbn": "9787543237223",
				"publisher": "上海人民出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4887493,
				"gid": 4887493,
				"goodsType": 1,
				"price": 98.0000,
				"discount": 1,
				"discountPrice": 98.0000,
				"currency": 1,
				"createTime": "2026-03-03 13:58:39",
				"cnIbraryType": "F49",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/SZybQ8SPl.jpg",
				"topic": "平台经济学:概念与战略",
				"title": "平台经济学:概念与战略",
				"author": "",
				"isbn": "9787543236998",
				"publisher": "上海人民出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4734555,
				"gid": 4734555,
				"goodsType": 1,
				"price": 78.0000,
				"discount": 1,
				"discountPrice": 78.0000,
				"currency": 1,
				"createTime": "2026-03-03 14:29:48",
				"cnIbraryType": "F426.5",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/uLh9rptn4.jpg",
				"topic": "大航天时代:逐浪变革的中国商业航天",
				"title": "大航天时代:逐浪变革的中国商业航天",
				"author": "刘畅著",
				"isbn": "9787520740425",
				"publisher": "东方出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4961609,
				"gid": 4961609,
				"goodsType": 1,
				"price": 56.0000,
				"discount": 1,
				"discountPrice": 56.0000,
				"currency": 1,
				"createTime": "2026-03-03 16:01:26",
				"cnIbraryType": "F0-53",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/p5mRey4jo.jpg",
				"topic": "AI、通胀与武器",
				"title": "AI、通胀与武器",
				"author": "海闻 主编",
				"isbn": "9787301364567",
				"publisher": "北京大学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4959459,
				"gid": 4959459,
				"goodsType": 1,
				"price": 69.0000,
				"discount": 1,
				"discountPrice": 69.0000,
				"currency": 1,
				"createTime": "2026-03-03 16:01:27",
				"cnIbraryType": "F224.0",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/08Q8Rf63w.jpg",
				"topic": "机器学习与数量宏观经济学",
				"title": "机器学习与数量宏观经济学",
				"author": "冯志钢 著, 李小平 译",
				"isbn": "9787301365236",
				"publisher": "北京大学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4997240,
				"gid": 4997240,
				"goodsType": 1,
				"price": 89.0000,
				"discount": 1,
				"discountPrice": 89.0000,
				"currency": 1,
				"createTime": "2026-03-03 16:01:27",
				"cnIbraryType": "F713.8",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/hLZIW08Vu.jpg",
				"topic": "升维竞争：中国广告业资本化模式与经验",
				"title": "升维竞争：中国广告业资本化模式与经验",
				"author": "陈刚 主编, 刘志一 著",
				"isbn": "9787301369746",
				"publisher": "北京大学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4896394,
				"gid": 4896394,
				"goodsType": 1,
				"price": 88.0000,
				"discount": 1,
				"discountPrice": 88.0000,
				"currency": 1,
				"createTime": "2026-03-03 16:12:20",
				"cnIbraryType": "F592.3-53",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/bh6bgx19p.jpg",
				"topic": "文旅中的当代中国·第一辑·看见中国",
				"title": "文旅中的当代中国·第一辑·看见中国",
				"author": "周庆富 编",
				"isbn": "9787503978616",
				"publisher": "文化艺术出版社",
				"selectNum": 0,
				"allNum": 0
			}]
		}
	},
	"10146": {
		"status": true,
		"code": "200",
		"msg": "success",
		"errorMsg": "",
		"data": {
			"total": 0,
			"size": 8,
			"pages": 0,
			"current": 1,
			"records": [{
				"goodsId": 4977929,
				"gid": 4977929,
				"goodsType": 1,
				"price": 78.0000,
				"discount": 1,
				"discountPrice": 78.0000,
				"currency": 1,
				"createTime": "2026-03-03 13:58:37",
				"cnIbraryType": "TP301.6",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/mj0y8Pqdn.jpg",
				"topic": "智识共生:数智社会中的算法伦理与社会建设(“人工智能伦理、法律与治理”系列丛书)",
				"title": "智识共生:数智社会中的算法伦理与社会建设(“人工智能伦理、法律与治理”系列丛书)",
				"author": "",
				"isbn": "9787208197176",
				"publisher": "上海人民出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4989659,
				"gid": 4989659,
				"goodsType": 1,
				"price": 45.0000,
				"discount": 1,
				"discountPrice": 45.0000,
				"currency": 1,
				"createTime": "2026-03-03 16:01:26",
				"cnIbraryType": "TP312.8C",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/7LOmMhzMH.jpg",
				"topic": "企业级项目综合实战教程——基于C/C++",
				"title": "企业级项目综合实战教程——基于C/C++",
				"author": "李娟 主编",
				"isbn": "9787301369326",
				"publisher": "北京大学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4962075,
				"gid": 4962075,
				"goodsType": 1,
				"price": 99.0000,
				"discount": 1,
				"discountPrice": 99.0000,
				"currency": 1,
				"createTime": "2026-03-03 16:01:26",
				"cnIbraryType": "TP391.13",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/FjgK0FSwL.jpg",
				"topic": "精进Excel：AI赋能，成为Excel高手",
				"title": "精进Excel：AI赋能，成为Excel高手",
				"author": "周庆麟,孔长征,周奎奎 著",
				"isbn": "9787301367469",
				"publisher": "北京大学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4961573,
				"gid": 4961573,
				"goodsType": 1,
				"price": 99.0000,
				"discount": 1,
				"discountPrice": 99.0000,
				"currency": 1,
				"createTime": "2026-03-03 16:01:26",
				"cnIbraryType": "TP391.412",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/521QHb3tR.jpg",
				"topic": "精进PPT：AI赋能，成为PPT高手",
				"title": "精进PPT：AI赋能，成为PPT高手",
				"author": "周庆麟,胡子平 著",
				"isbn": "9787301368039",
				"publisher": "北京大学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4963755,
				"gid": 4963755,
				"goodsType": 1,
				"price": 99.0000,
				"discount": 1,
				"discountPrice": 99.0000,
				"currency": 1,
				"createTime": "2026-03-03 16:01:26",
				"cnIbraryType": "TP312.8",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/7djxKBZhu.jpg",
				"topic": "仓颉编程从入门到实践",
				"title": "仓颉编程从入门到实践",
				"author": "柳伟卫 著",
				"isbn": "9787301360873",
				"publisher": "北京大学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4959389,
				"gid": 4959389,
				"goodsType": 1,
				"price": 119.0000,
				"discount": 1,
				"discountPrice": 119.0000,
				"currency": 1,
				"createTime": "2026-03-03 16:01:26",
				"cnIbraryType": "TP312.8PY",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/L9I8LfL4Z.jpg",
				"topic": "Python路径规划与决策算法",
				"title": "Python路径规划与决策算法",
				"author": "张良康 著",
				"isbn": "9787301366738",
				"publisher": "北京大学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4961576,
				"gid": 4961576,
				"goodsType": 1,
				"price": 99.0000,
				"discount": 1,
				"discountPrice": 99.0000,
				"currency": 1,
				"createTime": "2026-03-03 16:01:26",
				"cnIbraryType": "TP391.13",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/dcGMghcvf.jpg",
				"topic": "精进Excel图表：AI赋能，成为Excel图表高手",
				"title": "精进Excel图表：AI赋能，成为Excel图表高手",
				"author": "周庆麟,孔长征,周奎奎 著",
				"isbn": "9787301366264",
				"publisher": "北京大学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4989658,
				"gid": 4989658,
				"goodsType": 1,
				"price": 49.0000,
				"discount": 1,
				"discountPrice": 49.0000,
				"currency": 1,
				"createTime": "2026-03-03 16:01:27",
				"cnIbraryType": "TP3",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/VAMOSTSfL.jpg",
				"topic": "大学计算机基础实验教程",
				"title": "大学计算机基础实验教程",
				"author": "赵立英,王帆,刘帅 主编",
				"isbn": "9787301369647",
				"publisher": "北京大学出版社",
				"selectNum": 0,
				"allNum": 0
			}]
		}
	},
	"10147": {
		"status": true,
		"code": "200",
		"msg": "success",
		"errorMsg": "",
		"data": {
			"total": 0,
			"size": 8,
			"pages": 0,
			"current": 1,
			"records": [{
				"goodsId": 4979446,
				"gid": 4979446,
				"goodsType": 1,
				"price": 128.0000,
				"discount": 1,
				"discountPrice": 128.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:56:59",
				"cnIbraryType": "G571.2",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/nuaycmFXK.jpg",
				"topic": "学以自由？：美国建国者的教育理念",
				"title": "学以自由？：美国建国者的教育理念",
				"author": "[美]托马斯·潘戈 [美]罗兰·史密斯·潘戈",
				"isbn": "9787108081025",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4901525,
				"gid": 4901525,
				"goodsType": 1,
				"price": 45.0000,
				"discount": 1,
				"discountPrice": 45.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:56:59",
				"cnIbraryType": "G40-095.61",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/3vOFuuHp9.jpg",
				"topic": "论教育",
				"title": "论教育",
				"author": "[英]伯特兰·罗素",
				"isbn": "9787108081162",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4914316,
				"gid": 4914316,
				"goodsType": 1,
				"price": 58.0000,
				"discount": 1,
				"discountPrice": 58.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:56:59",
				"cnIbraryType": "G519",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/jYkwjAlHv.jpg",
				"topic": "学生简史：理想教育何以成人",
				"title": "学生简史：理想教育何以成人",
				"author": "[美]迈克尔·罗斯",
				"isbn": "9787108081087",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4967699,
				"gid": 4967699,
				"goodsType": 1,
				"price": 75.0000,
				"discount": 1,
				"discountPrice": 75.0000,
				"currency": 1,
				"createTime": "2026-03-03 10:11:25",
				"cnIbraryType": "G40-097.12",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/AX4MB4GPb.jpg",
				"topic": "新文化运动中的杜威：“实用主义”的变奏",
				"title": "新文化运动中的杜威：“实用主义”的变奏",
				"author": "龚世琳 著",
				"isbn": "9787100254939",
				"publisher": "商务印书馆有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4969907,
				"gid": 4969907,
				"goodsType": 1,
				"price": 38.0000,
				"discount": 1,
				"discountPrice": 38.0000,
				"currency": 1,
				"createTime": "2026-03-03 10:11:26",
				"cnIbraryType": "G633.302",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/fckVuiCPX.jpg",
				"topic": "课内讲读与课外指导",
				"title": "课内讲读与课外指导",
				"author": "蒋伯潜 著",
				"isbn": "9787100253666",
				"publisher": "商务印书馆有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4972421,
				"gid": 4972421,
				"goodsType": 1,
				"price": 98.0000,
				"discount": 1,
				"discountPrice": 98.0000,
				"currency": 1,
				"createTime": "2026-03-03 10:11:26",
				"cnIbraryType": "G649.21-53",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/S524zSe6R.jpg",
				"topic": "大学的发展路径",
				"title": "大学的发展路径",
				"author": "张炜 著",
				"isbn": "9787100258906",
				"publisher": "商务印书馆有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4986969,
				"gid": 4986969,
				"goodsType": 1,
				"price": 68.0000,
				"discount": 1,
				"discountPrice": 68.0000,
				"currency": 1,
				"createTime": "2026-03-03 10:11:26",
				"cnIbraryType": "G649.21",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/rWSMtPpY3.jpg",
				"topic": "高等教育普及化：中国道路与国际实践",
				"title": "高等教育普及化：中国道路与国际实践",
				"author": "别敦荣 吴薇 主编",
				"isbn": "9787100257527",
				"publisher": "商务印书馆有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 5002397,
				"gid": 5002397,
				"goodsType": 1,
				"price": 62.0000,
				"discount": 1,
				"discountPrice": 62.0000,
				"currency": 1,
				"createTime": "2026-03-03 10:11:26",
				"cnIbraryType": "G643-53",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/l8x5pkcXw.jpg",
				"topic": "研究生教育发展论",
				"title": "研究生教育发展论",
				"author": "别敦荣 等著",
				"isbn": "9787100259828",
				"publisher": "商务印书馆有限公司",
				"selectNum": 0,
				"allNum": 0
			}]
		}
	},
	"10149": {
		"status": true,
		"code": "200",
		"msg": "success",
		"errorMsg": "",
		"data": {
			"total": 0,
			"size": 8,
			"pages": 0,
			"current": 1,
			"records": [{
				"goodsId": 4887791,
				"gid": 4887791,
				"goodsType": 1,
				"price": 88.0000,
				"discount": 1,
				"discountPrice": 88.0000,
				"currency": 1,
				"createTime": "2026-02-28 14:36:28",
				"cnIbraryType": "J292.4-53",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/s9Q9JzYGa.jpg",
				"topic": "耕石印语：中国篆刻之美",
				"title": "耕石印语：中国篆刻之美",
				"author": "夏宇 著",
				"isbn": "9787549645756",
				"publisher": "文汇出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4867449,
				"gid": 4867449,
				"goodsType": 1,
				"price": 89.0000,
				"discount": 1,
				"discountPrice": 89.0000,
				"currency": 1,
				"createTime": "2026-02-28 16:10:13",
				"cnIbraryType": "J60-05",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/CY09DT37i.jpg",
				"topic": "音乐与人类（馆配定制）",
				"title": "音乐与人类（馆配定制）",
				"author": "迈克尔·斯皮策",
				"isbn": "9787549644889",
				"publisher": "文汇出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 5010720,
				"gid": 5010720,
				"goodsType": 1,
				"price": 68.0000,
				"discount": 1,
				"discountPrice": 68.0000,
				"currency": 1,
				"createTime": "2026-03-02 09:25:58",
				"cnIbraryType": "J912.2",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/683uwb6JT.jpg",
				"topic": "中国电影表演教学的路径建构",
				"title": "中国电影表演教学的路径建构",
				"author": "益才",
				"isbn": "9787106057169",
				"publisher": "中国电影出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 5010716,
				"gid": 5010716,
				"goodsType": 1,
				"price": 98.0000,
				"discount": 1,
				"discountPrice": 98.0000,
				"currency": 1,
				"createTime": "2026-03-02 09:25:58",
				"cnIbraryType": "J909.2",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/sneq8nhAU.jpg",
				"topic": "中国电影与中国文化",
				"title": "中国电影与中国文化",
				"author": "杨晓林",
				"isbn": "9787106057510",
				"publisher": "中国电影出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4988883,
				"gid": 4988883,
				"goodsType": 1,
				"price": 128.0000,
				"discount": 1,
				"discountPrice": 128.0000,
				"currency": 1,
				"createTime": "2026-03-02 09:25:58",
				"cnIbraryType": "J41",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/MOEYcyHxo.jpg",
				"topic": "成为摄影师--电影运动影像思维",
				"title": "成为摄影师--电影运动影像思维",
				"author": "曾念平",
				"isbn": "9787106058166",
				"publisher": "中国电影出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4947224,
				"gid": 4947224,
				"goodsType": 1,
				"price": 49.8000,
				"discount": 1,
				"discountPrice": 49.8000,
				"currency": 1,
				"createTime": "2026-03-02 11:43:29",
				"cnIbraryType": "J892.4",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/XvTPiNScB.jpg",
				"topic": "戏剧剧目排演",
				"title": "戏剧剧目排演",
				"author": "陈俊",
				"isbn": "9787548763499",
				"publisher": "中南大学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4876646,
				"gid": 4876646,
				"goodsType": 1,
				"price": 160.0000,
				"discount": 1,
				"discountPrice": 160.0000,
				"currency": 1,
				"createTime": "2026-03-03 10:05:44",
				"cnIbraryType": "J212.6",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/0P273Dxeo.jpg",
				"topic": "中国外销画的材料、技术与保护",
				"title": "中国外销画的材料、技术与保护",
				"author": "王斌 著",
				"isbn": "9787547872086",
				"publisher": "上海科学技术出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4968943,
				"gid": 4968943,
				"goodsType": 1,
				"price": 98.0000,
				"discount": 1,
				"discountPrice": 98.0000,
				"currency": 1,
				"createTime": "2026-03-03 14:17:51",
				"cnIbraryType": "J224.8",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/ulCUmVHRa.jpg",
				"topic": "搜山集：杨惟为2015-2024写生作品",
				"title": "搜山集：杨惟为2015-2024写生作品",
				"author": "杨惟为，著绘",
				"isbn": "9787522538815",
				"publisher": "九州出版社",
				"selectNum": 0,
				"allNum": 0
			}]
		}
	},
	"10150": {
		"status": true,
		"code": "200",
		"msg": "success",
		"errorMsg": "",
		"data": {
			"total": 0,
			"size": 8,
			"pages": 0,
			"current": 1,
			"records": [{
				"goodsId": 4990949,
				"gid": 4990949,
				"goodsType": 1,
				"price": 86.0000,
				"discount": 1,
				"discountPrice": 86.0000,
				"currency": 1,
				"createTime": "2026-03-03 14:17:51",
				"cnIbraryType": "TM911",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/v2UWZEIgG.jpg",
				"topic": "全钒液流电池储能系统智能控制与应用",
				"title": "全钒液流电池储能系统智能控制与应用",
				"author": "陆鹏，著",
				"isbn": "9787522142272",
				"publisher": "中国原子能出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4776094,
				"gid": 4776094,
				"goodsType": 1,
				"price": 82.0000,
				"discount": 1,
				"discountPrice": 82.0000,
				"currency": 1,
				"createTime": "2026-03-03 14:17:52",
				"cnIbraryType": "TM271",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/YXwZq6QaV.jpg",
				"topic": "钼基分子磁性材料的研究",
				"title": "钼基分子磁性材料的研究",
				"author": "卫晓琴，著",
				"isbn": "9787577008011",
				"publisher": "电子科技大学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4955736,
				"gid": 4955736,
				"goodsType": 1,
				"price": 89.0000,
				"discount": 1,
				"discountPrice": 89.0000,
				"currency": 1,
				"createTime": "2026-03-03 16:01:26",
				"cnIbraryType": "TN948.4",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/V1YzOXM3s.jpg",
				"topic": "运营助手：AI短视频与直播  策划+制作+多平台运营一本通",
				"title": "运营助手：AI短视频与直播  策划+制作+多平台运营一本通",
				"author": "全权 编著",
				"isbn": "9787301367858",
				"publisher": "北京大学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 5001288,
				"gid": 5001288,
				"goodsType": 1,
				"price": 119.0000,
				"discount": 1,
				"discountPrice": 119.0000,
				"currency": 1,
				"createTime": "2026-03-03 16:01:27",
				"cnIbraryType": "TN929.53",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/xQPSVOIFI.jpg",
				"topic": "鸿蒙架构师修炼之道",
				"title": "鸿蒙架构师修炼之道",
				"author": "柳伟卫 著",
				"isbn": "9787301365021",
				"publisher": "北京大学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4854758,
				"gid": 4854758,
				"goodsType": 1,
				"price": 49.0000,
				"discount": 1,
				"discountPrice": 49.0000,
				"currency": 1,
				"createTime": "2026-03-03 16:01:36",
				"cnIbraryType": "TN948.4-39",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/7kPbZpjgI.jpg",
				"topic": "AI短视频制作完全攻略",
				"title": "AI短视频制作完全攻略",
				"author": "时代飞鹰 编著",
				"isbn": "9787301360866",
				"publisher": "北京大学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4859297,
				"gid": 4859297,
				"goodsType": 1,
				"price": 88.0000,
				"discount": 1,
				"discountPrice": 88.0000,
				"currency": 1,
				"createTime": "2026-03-04 15:19:23",
				"cnIbraryType": "TN929.5",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/phGE5oVbI.jpg",
				"topic": "边缘计算中的智能调度与资源部署",
				"title": "边缘计算中的智能调度与资源部署",
				"author": "陈卓",
				"isbn": "9787568950152",
				"publisher": "重庆大学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 5013111,
				"gid": 5013111,
				"goodsType": 1,
				"price": 88.0000,
				"discount": 1,
				"discountPrice": 88.0000,
				"currency": 1,
				"createTime": "2026-03-04 15:47:53",
				"cnIbraryType": "TM911",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/BBP5gyrjL.jpg",
				"topic": "锂电池正极用匣钵耐火材料",
				"title": "锂电池正极用匣钵耐火材料",
				"author": "翟鹏涛",
				"isbn": "9787524307518",
				"publisher": "经济管理出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4975178,
				"gid": 4975178,
				"goodsType": 1,
				"price": 78.0000,
				"discount": 1,
				"discountPrice": 78.0000,
				"currency": 1,
				"createTime": "2026-03-05 15:28:39",
				"cnIbraryType": "TN95",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/UpgLegHT8.jpg",
				"topic": "被动雷达原理",
				"title": "被动雷达原理",
				"author": "王春阳，宫健，蔡继亮，刘明杰，周长霖，陈赓",
				"isbn": "9787118139433",
				"publisher": "国防工业出版社",
				"selectNum": 0,
				"allNum": 0
			}]
		}
	},
	"10151": {
		"status": true,
		"code": "200",
		"msg": "success",
		"errorMsg": "",
		"data": {
			"total": 0,
			"size": 8,
			"pages": 0,
			"current": 1,
			"records": [{
				"goodsId": 4851563,
				"gid": 4851563,
				"goodsType": 1,
				"price": 60.0000,
				"discount": 1,
				"discountPrice": 60.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:53:20",
				"cnIbraryType": "U448.43",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/WHrTWZEr4.jpg",
				"topic": "大跨度桥梁设计与转体桥施工研究",
				"title": "大跨度桥梁设计与转体桥施工研究",
				"author": "贺婷, 焦长洲,王兵主编",
				"isbn": "9787563987474",
				"publisher": "北京工业大学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4950224,
				"gid": 4950224,
				"goodsType": 1,
				"price": 68.0000,
				"discount": 1,
				"discountPrice": 68.0000,
				"currency": 1,
				"createTime": "2026-03-02 11:43:30",
				"cnIbraryType": "U495",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/k9dBnjJjS.jpg",
				"topic": "智能交通中的关键技术研究——从导航、目标检测到行为识别",
				"title": "智能交通中的关键技术研究——从导航、目标检测到行为识别",
				"author": "刘述民",
				"isbn": "9787548761686",
				"publisher": "中南大学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4977671,
				"gid": 4977671,
				"goodsType": 1,
				"price": 78.0000,
				"discount": 1,
				"discountPrice": 78.0000,
				"currency": 1,
				"createTime": "2026-03-02 11:43:30",
				"cnIbraryType": "U455",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/Dyzqt2d35.jpg",
				"topic": "复杂环境隧道注浆加固围岩体力学性能劣化机理研究",
				"title": "复杂环境隧道注浆加固围岩体力学性能劣化机理研究",
				"author": "何如",
				"isbn": "9787548765936",
				"publisher": "中南大学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4800416,
				"gid": 4800416,
				"goodsType": 1,
				"price": 69.0000,
				"discount": 1,
				"discountPrice": 69.0000,
				"currency": 1,
				"createTime": "2026-03-03 10:48:14",
				"cnIbraryType": "U463",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/UUqM2XsVj.jpg",
				"topic": "起重机底盘液压混合动力系统研究",
				"title": "起重机底盘液压混合动力系统研究",
				"author": "陈有权著",
				"isbn": "9787576836011",
				"publisher": "吉林大学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4816478,
				"gid": 4816478,
				"goodsType": 1,
				"price": 66.0000,
				"discount": 1,
				"discountPrice": 66.0000,
				"currency": 1,
				"createTime": "2026-03-03 10:48:14",
				"cnIbraryType": "U416.1",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/jh4bbOrxs.jpg",
				"topic": "岩体边坡锚固结构体系安全性评价指标体系研究",
				"title": "岩体边坡锚固结构体系安全性评价指标体系研究",
				"author": "夏鹏著",
				"isbn": "9787576834130",
				"publisher": "吉林大学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4880249,
				"gid": 4880249,
				"goodsType": 1,
				"price": 98.0000,
				"discount": 1,
				"discountPrice": 98.0000,
				"currency": 1,
				"createTime": "2026-03-03 13:58:39",
				"cnIbraryType": "U65",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/ldNu3XpRH.jpg",
				"topic": "迈向零碳中国:“双碳”战略下绿色港口的发展实践(高质量发展与强国建设论丛)",
				"title": "迈向零碳中国:“双碳”战略下绿色港口的发展实践(高质量发展与强国建设论丛)",
				"author": "",
				"isbn": "9787547621592",
				"publisher": "上海人民出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4795116,
				"gid": 4795116,
				"goodsType": 1,
				"price": 320.0000,
				"discount": 1,
				"discountPrice": 320.0000,
				"currency": 1,
				"createTime": "2026-03-03 15:27:37",
				"cnIbraryType": "U416.217",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/ISS50FKJ1.jpg",
				"topic": "沥青路面动力响应研究(第二版)",
				"title": "沥青路面动力响应研究(第二版)",
				"author": "谭忆秋,",
				"isbn": "9787030747556",
				"publisher": "科学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4829724,
				"gid": 4829724,
				"goodsType": 1,
				"price": 238.0000,
				"discount": 1,
				"discountPrice": 238.0000,
				"currency": 1,
				"createTime": "2026-03-03 15:27:37",
				"cnIbraryType": "U416.1",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/6buaEflBg.jpg",
				"topic": "冻融土力学行为及路基动力变形特性",
				"title": "冻融土力学行为及路基动力变形特性",
				"author": "冯德成,",
				"isbn": "9787030747006",
				"publisher": "科学出版社",
				"selectNum": 0,
				"allNum": 0
			}]
		}
	},
	"10152": {
		"status": true,
		"code": "200",
		"msg": "success",
		"errorMsg": "",
		"data": {
			"total": 0,
			"size": 8,
			"pages": 0,
			"current": 1,
			"records": [{
				"goodsId": 4794766,
				"gid": 4794766,
				"goodsType": 1,
				"price": 78.0000,
				"discount": 1,
				"discountPrice": 78.0000,
				"currency": 1,
				"createTime": "2026-02-28 08:33:15",
				"cnIbraryType": "TU984.191",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/iKed1DvYz.jpg",
				"topic": "媒介文化研究丛书：城市文化街区及其媒介空间多元建构",
				"title": "媒介文化研究丛书：城市文化街区及其媒介空间多元建构",
				"author": "王利民",
				"isbn": "9787523216965",
				"publisher": "世界图书",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4981838,
				"gid": 4981838,
				"goodsType": 1,
				"price": 69.0000,
				"discount": 1,
				"discountPrice": 69.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:56:59",
				"cnIbraryType": "TP274",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/wa0zb5FWS.jpg",
				"topic": "论数据",
				"title": "论数据",
				"author": "周傲英",
				"isbn": "9787108082558",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4820616,
				"gid": 4820616,
				"goodsType": 1,
				"price": 228.0000,
				"discount": 1,
				"discountPrice": 228.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:57:00",
				"cnIbraryType": "TU-092.2",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/sJ6LAKvAI.jpg",
				"topic": "天下文明：紫禁城规划思想与古代中国",
				"title": "天下文明：紫禁城规划思想与古代中国",
				"author": "王军",
				"isbn": "9787108078278",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4730185,
				"gid": 4730185,
				"goodsType": 1,
				"price": 178.0000,
				"discount": 1,
				"discountPrice": 178.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:57:00",
				"cnIbraryType": "TU-091",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/GtA6vrBZP.jpg",
				"topic": "现代建筑：一部批判的历史：第五版",
				"title": "现代建筑：一部批判的历史：第五版",
				"author": "[美]肯尼斯·弗兰姆普敦",
				"isbn": "9787108077875",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4973410,
				"gid": 4973410,
				"goodsType": 1,
				"price": 98.0000,
				"discount": 1,
				"discountPrice": 98.0000,
				"currency": 1,
				"createTime": "2026-03-03 10:05:44",
				"cnIbraryType": "TU723.3-39",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/7X1iwOtNc.jpg",
				"topic": "房屋建筑工程造价估算指标和数字化应用",
				"title": "房屋建筑工程造价估算指标和数字化应用",
				"author": "上海申元工程投资咨询有限公司 编著",
				"isbn": "9787547874387",
				"publisher": "上海科学技术出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4915383,
				"gid": 4915383,
				"goodsType": 1,
				"price": 98.0000,
				"discount": 1,
				"discountPrice": 98.0000,
				"currency": 1,
				"createTime": "2026-03-03 10:05:44",
				"cnIbraryType": "TH322",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/DPk5Plfur.jpg",
				"topic": "高性能液压柱塞泵关键材料及工艺技术",
				"title": "高性能液压柱塞泵关键材料及工艺技术",
				"author": "卢岳良 金肖同 刘高群 编著",
				"isbn": "9787547873434",
				"publisher": "上海科学技术出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4979695,
				"gid": 4979695,
				"goodsType": 1,
				"price": 82.0000,
				"discount": 1,
				"discountPrice": 82.0000,
				"currency": 1,
				"createTime": "2026-03-03 13:58:37",
				"cnIbraryType": "TP181",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/87yesYNrL.jpg",
				"topic": "算法焦虑:数字时代的恐惧",
				"title": "算法焦虑:数字时代的恐惧",
				"author": "",
				"isbn": "9787543237216",
				"publisher": "上海人民出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4972900,
				"gid": 4972900,
				"goodsType": 1,
				"price": 79.0000,
				"discount": 1,
				"discountPrice": 79.0000,
				"currency": 1,
				"createTime": "2026-03-03 16:01:26",
				"cnIbraryType": "TB472-39",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/SiUmJ7EBM.jpg",
				"topic": "AI产品设计创作：基于Midjourney的智能设计与应用",
				"title": "AI产品设计创作：基于Midjourney的智能设计与应用",
				"author": "张锐,邱棋 著",
				"isbn": "9787301368114",
				"publisher": "北京大学出版社",
				"selectNum": 0,
				"allNum": 0
			}]
		}
	},
	"10153": {
		"status": true,
		"code": "200",
		"msg": "success",
		"errorMsg": "",
		"data": {
			"total": 0,
			"size": 8,
			"pages": 0,
			"current": 1,
			"records": [{
				"goodsId": 5013875,
				"gid": 5013875,
				"goodsType": 1,
				"price": 78.0000,
				"discount": 1,
				"discountPrice": 78.0000,
				"currency": 1,
				"createTime": "2026-02-28 08:33:14",
				"cnIbraryType": "X4",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/xOakfBguZ.jpg",
				"topic": "灾害外交：救援如何影响和平与冲突",
				"title": "灾害外交：救援如何影响和平与冲突",
				"author": "(英)伊兰·凯尔曼",
				"isbn": "9787509019887",
				"publisher": "当代世界",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4982472,
				"gid": 4982472,
				"goodsType": 1,
				"price": 75.0000,
				"discount": 1,
				"discountPrice": 75.0000,
				"currency": 1,
				"createTime": "2026-03-03 09:41:25",
				"cnIbraryType": "X503",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/3RmkUzNag.jpg",
				"topic": "极限问题：环境危机的历史透视",
				"title": "极限问题：环境危机的历史透视",
				"author": "克里斯蒂安·马鲁比",
				"isbn": "9787542884787",
				"publisher": "上海科技教育出版社有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4895207,
				"gid": 4895207,
				"goodsType": 1,
				"price": 145.0000,
				"discount": 1,
				"discountPrice": 145.0000,
				"currency": 1,
				"createTime": "2026-03-03 10:05:44",
				"cnIbraryType": "S968.3",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/tEjAkfbRu.jpg",
				"topic": "滩涂贝类养殖装备与技术",
				"title": "滩涂贝类养殖装备与技术",
				"author": "李秀辰 张国琛 母刚 等 著",
				"isbn": "9787547873281",
				"publisher": "上海科学技术出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4989084,
				"gid": 4989084,
				"goodsType": 1,
				"price": 180.0000,
				"discount": 1,
				"discountPrice": 180.0000,
				"currency": 1,
				"createTime": "2026-03-03 10:05:44",
				"cnIbraryType": "S314",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/qVbCcfkbw.jpg",
				"topic": "作物群体质量",
				"title": "作物群体质量",
				"author": "张洪程 等 编著",
				"isbn": "9787547874325",
				"publisher": "上海科学技术出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4705706,
				"gid": 4705706,
				"goodsType": 1,
				"price": 110.0000,
				"discount": 1,
				"discountPrice": 110.0000,
				"currency": 1,
				"createTime": "2026-03-03 13:58:41",
				"cnIbraryType": "S863",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/JeTBcxm8P.jpg",
				"topic": "为动物而战:19世纪英国动物保护中的传统挪用",
				"title": "为动物而战:19世纪英国动物保护中的传统挪用",
				"author": "",
				"isbn": "9787545220087",
				"publisher": "上海人民出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4989788,
				"gid": 4989788,
				"goodsType": 1,
				"price": 98.0000,
				"discount": 1,
				"discountPrice": 98.0000,
				"currency": 1,
				"createTime": "2026-03-03 16:01:27",
				"cnIbraryType": "X321",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/tsYju4sJJ.jpg",
				"topic": "博弈与均衡：区域环境治理的府际逻辑与制度创新",
				"title": "博弈与均衡：区域环境治理的府际逻辑与制度创新",
				"author": "张振波 著",
				"isbn": "9787301369791",
				"publisher": "北京大学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4808277,
				"gid": 4808277,
				"goodsType": 1,
				"price": 79.0000,
				"discount": 1,
				"discountPrice": 79.0000,
				"currency": 1,
				"createTime": "2026-03-03 16:01:38",
				"cnIbraryType": "S154.5",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/auSwTIarM.jpg",
				"topic": "腐殖土的形成与蚯蚓的作用",
				"title": "腐殖土的形成与蚯蚓的作用",
				"author": "查尔斯·达尔文 著, 舒立福 译",
				"isbn": "9787301360507",
				"publisher": "北京大学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 5006915,
				"gid": 5006915,
				"goodsType": 1,
				"price": 98.0000,
				"discount": 1,
				"discountPrice": 98.0000,
				"currency": 1,
				"createTime": "2026-03-03 16:23:44",
				"cnIbraryType": "X321.2",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/OvLsG5IiN.jpg",
				"topic": "美丽中国：走向生态文明",
				"title": "美丽中国：走向生态文明",
				"author": "俞孔坚 著",
				"isbn": "9787574903722",
				"publisher": "花城出版社",
				"selectNum": 0,
				"allNum": 0
			}]
		}
	},
	"10154": {
		"status": true,
		"code": "200",
		"msg": "success",
		"errorMsg": "",
		"data": {
			"total": 0,
			"size": 8,
			"pages": 0,
			"current": 1,
			"records": [{
				"goodsId": 4584880,
				"gid": 4584880,
				"goodsType": 1,
				"price": 69.0000,
				"discount": 1,
				"discountPrice": 69.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:57:00",
				"cnIbraryType": "R512.91-091",
				"imageUrl": "http://img2.winxuancdn.com/4529/1203314529_0_1_800x800.jpg?1713254857791",
				"topic": "流行病的应对：西方工业化国家的公共卫生发展：19—20世纪",
				"title": "流行病的应对：西方工业化国家的公共卫生发展：19—20世纪",
				"author": "[美]彼得·鲍德温",
				"isbn": "9787108076557",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4548615,
				"gid": 4548615,
				"goodsType": 1,
				"price": 56.0000,
				"discount": 1,
				"discountPrice": 56.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:57:00",
				"cnIbraryType": "R48",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/I4oIpy32j.jpg",
				"topic": "生命的最后一公里：关于死亡，我们知道什么，我们能做什么，我们该如何面对",
				"title": "生命的最后一公里：关于死亡，我们知道什么，我们能做什么，我们该如何面对",
				"author": "[德]吉安·波拉西奥",
				"isbn": "9787108077141",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4540371,
				"gid": 4540371,
				"goodsType": 1,
				"price": 68.0000,
				"discount": 1,
				"discountPrice": 68.0000,
				"currency": 1,
				"createTime": "2026-02-28 09:57:01",
				"cnIbraryType": "R184.6",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/NyrR8g3zZ.jpg",
				"topic": "隔离：防疫安全线的历史与未来",
				"title": "隔离：防疫安全线的历史与未来",
				"author": "[美]杰夫·马纳夫 [美]妮古拉·特莉",
				"isbn": "9787108077172",
				"publisher": "生活·读书·新知三联书店有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4972738,
				"gid": 4972738,
				"goodsType": 1,
				"price": 98.0000,
				"discount": 1,
				"discountPrice": 98.0000,
				"currency": 1,
				"createTime": "2026-03-03 09:41:25",
				"cnIbraryType": "R737.9",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/tLCeXvNNc.jpg",
				"topic": "乳腺癌狙击战",
				"title": "乳腺癌狙击战",
				"author": "顾建春、李倩、李泓",
				"isbn": "9787542885265",
				"publisher": "上海科技教育出版社有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4972739,
				"gid": 4972739,
				"goodsType": 1,
				"price": 88.0000,
				"discount": 1,
				"discountPrice": 88.0000,
				"currency": 1,
				"createTime": "2026-03-03 09:41:25",
				"cnIbraryType": "R247.1",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/1F6KGV5fz.jpg",
				"topic": "本经注蔬  《神农本草经》解·药食同源谱",
				"title": "本经注蔬  《神农本草经》解·药食同源谱",
				"author": "李辉 著",
				"isbn": "9787542884633",
				"publisher": "上海科技教育出版社有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4963597,
				"gid": 4963597,
				"goodsType": 1,
				"price": 198.0000,
				"discount": 1,
				"discountPrice": 198.0000,
				"currency": 1,
				"createTime": "2026-03-03 10:05:44",
				"cnIbraryType": "R687.4-39",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/YXhrFStjF.jpg",
				"topic": "数智骨科：关节外科手术学",
				"title": "数智骨科：关节外科手术学",
				"author": "张先龙 王坤正 主编",
				"isbn": "9787547874332",
				"publisher": "上海科学技术出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4949459,
				"gid": 4949459,
				"goodsType": 1,
				"price": 168.0000,
				"discount": 1,
				"discountPrice": 168.0000,
				"currency": 1,
				"createTime": "2026-03-03 10:05:44",
				"cnIbraryType": "R654.2",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/r8yvbh1pl.jpg",
				"topic": "微创心脏外科手术精粹：CMC直播手术病例精选",
				"title": "微创心脏外科手术精粹：CMC直播手术病例精选",
				"author": "王春生 主编",
				"isbn": "9787547873533",
				"publisher": "上海科学技术出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4942924,
				"gid": 4942924,
				"goodsType": 1,
				"price": 88.0000,
				"discount": 1,
				"discountPrice": 88.0000,
				"currency": 1,
				"createTime": "2026-03-03 10:05:44",
				"cnIbraryType": "R97",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/rvHJU82fs.jpg",
				"topic": "药物临床研究设计与实践",
				"title": "药物临床研究设计与实践",
				"author": "邱晓霞 吴丽花 江波 主编",
				"isbn": "9787547873090",
				"publisher": "上海科学技术出版社",
				"selectNum": 0,
				"allNum": 0
			}]
		}
	},
	"10155": {
		"status": true,
		"code": "200",
		"msg": "success",
		"errorMsg": "",
		"data": {
			"total": 0,
			"size": 8,
			"pages": 0,
			"current": 1,
			"records": [{
				"goodsId": 5009988,
				"gid": 5009988,
				"goodsType": 1,
				"price": 52.0000,
				"discount": 1,
				"discountPrice": 52.0000,
				"currency": 1,
				"createTime": "2026-02-27 16:01:01",
				"cnIbraryType": "F830.59-49",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/S3cklLv2r.jpg",
				"topic": "AI风口赚钱术",
				"title": "AI风口赚钱术",
				"author": "洛水",
				"isbn": "9787547753316",
				"publisher": "北京日报出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4867165,
				"gid": 4867165,
				"goodsType": 1,
				"price": 88.0000,
				"discount": 1,
				"discountPrice": 88.0000,
				"currency": 1,
				"createTime": "2026-02-28 08:33:15",
				"cnIbraryType": "C912.1-39",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/5cSvQocE1.jpg",
				"topic": "马克思主义与人的发展理论研究丛书：人工智能时代人的发展研究",
				"title": "马克思主义与人的发展理论研究丛书：人工智能时代人的发展研究",
				"author": "邓春芝、吴玉龙",
				"isbn": "9787569728811",
				"publisher": "西南大学",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4962905,
				"gid": 4962905,
				"goodsType": 1,
				"price": 69.0000,
				"discount": 1,
				"discountPrice": 69.0000,
				"currency": 1,
				"createTime": "2026-03-03 16:01:26",
				"cnIbraryType": "D035-39",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/bKNkwRoFD.jpg",
				"topic": "智慧应急",
				"title": "智慧应急",
				"author": "雷晓康,周文光 主编",
				"isbn": "9787301367643",
				"publisher": "北京大学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4970295,
				"gid": 4970295,
				"goodsType": 1,
				"price": 89.0000,
				"discount": 1,
				"discountPrice": 89.0000,
				"currency": 1,
				"createTime": "2026-03-03 16:01:26",
				"cnIbraryType": "TN948.4-39",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/0EV7gCQZT.jpg",
				"topic": "AI运镜一本通：智能运镜+提示词技巧+短视频成片（即梦AI+可灵AI+海螺AI）",
				"title": "AI运镜一本通：智能运镜+提示词技巧+短视频成片（即梦AI+可灵AI+海螺AI）",
				"author": "木白 编著",
				"isbn": "9787301368275",
				"publisher": "北京大学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4962077,
				"gid": 4962077,
				"goodsType": 1,
				"price": 79.0000,
				"discount": 1,
				"discountPrice": 79.0000,
				"currency": 1,
				"createTime": "2026-03-03 16:01:27",
				"cnIbraryType": "TP391.413",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/Rw3hnilvP.jpg",
				"topic": "AI绘画教程：AI绘画工具使用方法与技巧从入门到精通",
				"title": "AI绘画教程：AI绘画工具使用方法与技巧从入门到精通",
				"author": "陆瑶,张文亮,周旖,洪刚 编著",
				"isbn": "9787301362372",
				"publisher": "北京大学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4902078,
				"gid": 4902078,
				"goodsType": 1,
				"price": 69.0000,
				"discount": 1,
				"discountPrice": 69.0000,
				"currency": 1,
				"createTime": "2026-03-03 16:01:30",
				"cnIbraryType": "TP18",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/mZQPuuI8r.jpg",
				"topic": "这就是DeepSeek：DeepSeek从原理到实践",
				"title": "这就是DeepSeek：DeepSeek从原理到实践",
				"author": "王卓,薛栋,隆建 著",
				"isbn": "9787301361696",
				"publisher": "北京大学出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 5008939,
				"gid": 5008939,
				"goodsType": 1,
				"price": 88.0000,
				"discount": 1,
				"discountPrice": 88.0000,
				"currency": 1,
				"createTime": "2026-03-04 09:55:37",
				"cnIbraryType": "F249.214-39",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/73VBoaW69.jpg",
				"topic": "人工智能背景下的就业结构重塑",
				"title": "人工智能背景下的就业结构重塑",
				"author": "王春超 郑筱婷 王爽心 王子成",
				"isbn": "9787517715597",
				"publisher": "中国发展出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 5013114,
				"gid": 5013114,
				"goodsType": 1,
				"price": 88.0000,
				"discount": 1,
				"discountPrice": 88.0000,
				"currency": 1,
				"createTime": "2026-03-04 15:47:53",
				"cnIbraryType": "F249.212-39",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/zUq3fmpub.jpg",
				"topic": "人工智能对中国劳动力市场的影响研究：跨行业的工作性质变化",
				"title": "人工智能对中国劳动力市场的影响研究：跨行业的工作性质变化",
				"author": "韩朝亮 吴英艳",
				"isbn": "9787524307402",
				"publisher": "经济管理出版社",
				"selectNum": 0,
				"allNum": 0
			}]
		}
	},
	"10156": {
		"status": true,
		"code": "200",
		"msg": "success",
		"errorMsg": "",
		"data": {
			"total": 0,
			"size": 8,
			"pages": 0,
			"current": 1,
			"records": [{
				"goodsId": 4981414,
				"gid": 4981414,
				"goodsType": 1,
				"price": 78.0000,
				"discount": 1,
				"discountPrice": 78.0000,
				"currency": 1,
				"createTime": "2026-03-04 09:18:04",
				"cnIbraryType": "C913.6",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/dOZ1HlqOl.jpg",
				"topic": "照亮黄昏:一名老年病医生的建议",
				"title": "照亮黄昏:一名老年病医生的建议",
				"author": "【英】露西·波洛克 著 彭小华、夏燕飞 译",
				"isbn": "9787532194070",
				"publisher": "上海文艺出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4987024,
				"gid": 4987024,
				"goodsType": 1,
				"price": 98.0000,
				"discount": 1,
				"discountPrice": 98.0000,
				"currency": 1,
				"createTime": "2026-03-04 09:18:04",
				"cnIbraryType": "I25",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/9t8q4MwCj.jpg",
				"topic": "大医无疆:共和国勋章获得者王振义",
				"title": "大医无疆:共和国勋章获得者王振义",
				"author": "李泓冰，朱凡 著",
				"isbn": "9787532194148",
				"publisher": "上海文艺出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 5011813,
				"gid": 5011813,
				"goodsType": 1,
				"price": 56.0000,
				"discount": 1,
				"discountPrice": 56.0000,
				"currency": 1,
				"createTime": "2026-03-04 09:18:04",
				"cnIbraryType": "K835.125.6",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/F15mlhmvo.jpg",
				"topic": "托尔斯泰小传",
				"title": "托尔斯泰小传",
				"author": "【英】安德烈·佐林 著 周唯 译",
				"isbn": "9787532194827",
				"publisher": "上海文艺出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4986397,
				"gid": 4986397,
				"goodsType": 1,
				"price": 2800.0000,
				"discount": 1,
				"discountPrice": 2800.0000,
				"currency": 1,
				"createTime": "2026-03-05 09:04:27",
				"cnIbraryType": "K877.54",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/yEsq4dLPP.jpg",
				"topic": "长沙走马楼三国吴简·竹木牍（上、中、下）",
				"title": "长沙走马楼三国吴简·竹木牍（上、中、下）",
				"author": "长沙简牍博物馆",
				"isbn": "9787501087969",
				"publisher": "文物出版社有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4867024,
				"gid": 4867024,
				"goodsType": 1,
				"price": 580.0000,
				"discount": 1,
				"discountPrice": 580.0000,
				"currency": 1,
				"createTime": "2026-03-05 09:04:27",
				"cnIbraryType": "K877.24-64",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/IdMgMaAud.jpg",
				"topic": "中国金石家题跋图典",
				"title": "中国金石家题跋图典",
				"author": "仲威",
				"isbn": "9787501084739",
				"publisher": "文物出版社有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 4682432,
				"gid": 4682432,
				"goodsType": 1,
				"price": 8800.0000,
				"discount": 1,
				"discountPrice": 8800.0000,
				"currency": 1,
				"createTime": "2026-03-05 09:04:27",
				"cnIbraryType": "K870.4",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/bls/qefGMUaHf.jpg",
				"topic": "台北故宫博物院典藏大系·绘画卷",
				"title": "台北故宫博物院典藏大系·绘画卷",
				"author": "李翰莹",
				"isbn": "9787501083190",
				"publisher": "文物出版社有限公司",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 3571961,
				"gid": 3571961,
				"goodsType": 1,
				"price": 45.0000,
				"discount": 1,
				"discountPrice": 45.0000,
				"currency": 1,
				"createTime": "2026-03-05 12:05:00",
				"cnIbraryType": "I247.56",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/erp/6jh8rf5bfz.jpg",
				"topic": "捕心师1：另一个世界",
				"title": "捕心师1：另一个世界",
				"author": "",
				"isbn": "9787229151492",
				"publisher": "重庆出版社",
				"selectNum": 0,
				"allNum": 0
			}, {
				"goodsId": 3571959,
				"gid": 3571959,
				"goodsType": 1,
				"price": 45.0000,
				"discount": 1,
				"discountPrice": 45.0000,
				"currency": 1,
				"createTime": "2026-03-05 12:05:00",
				"cnIbraryType": "I247.56",
				"imageUrl": "https://newcover.ytzhihui.com/newcover/erp/erp/b8h8nskl9a.jpg",
				"topic": "捕心师2：拯救迷路人",
				"title": "捕心师2：拯救迷路人",
				"author": "",
				"isbn": "9787229151508",
				"publisher": "重庆出版社",
				"selectNum": 0,
				"allNum": 0
			}]
		}
	}
}


// WEBPACK FOOTER //
// ./src/dataJson/hompagebookdata2.js